import React from 'react';
import { START_HOUR, END_HOUR } from './constants';
import { formatTime } from './timeUtils';

export default function TimeGutter() {
  const hours = [];
  for (let h = START_HOUR; h < END_HOUR; h++) {
    hours.push(h);
  }
  return (
    <div className="time-gutter w-20 flex flex-col bg-surface border-r border-border shrink-0">
      {hours.map((h) => (
        <div
          key={h}
          className="h-[60px] flex items-start justify-center pt-2 text-[11px] font-semibold text-text-secondary/60"
        >
          {formatTime(h, 0)}
        </div>
      ))}
    </div>
  );
}
